// LoginOrCreateAccount.js — Autenticação DENTRO do checkout.
//
// Fora do checkout as duas ações são páginas separadas (/login e /criar-conta).
// Aqui não dá para navegar para fora: o cliente perderia o carrinho no meio da
// compra. Então usamos as MESMAS telas em abas, num cartão único.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormEntrar, FormCriarConta, FormVerificarEmail, FormCompletarTelefone } from "./AuthForms";

const main = process.env.REACT_APP_MAIN;

const Aba = ({ ativa, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={
      "flex-1 py-3 text-sm font-semibold border-b-2 transition-colors " +
      (ativa
        ? "border-insigne-orange text-white"
        : "border-transparent text-white/50 hover:text-white/80")
    }
  >
    {children}
  </button>
);

const LoginOrCreateAccount = ({ navBlock, onNext }) => {
  const navigate = useNavigate();
  const [aba, setAba] = useState("entrar"); // 'entrar' | 'criar'
  const [emailParaVerificar, setEmailParaVerificar] = useState(null);
  // Login social sem telefone: pedimos o número aqui mesmo, no lugar das abas,
  // para não jogar quem está comprando para fora do checkout. É pulável, então
  // no pior caso o passo custa um clique antes de seguir para o pagamento.
  const [pedirTelefone, setPedirTelefone] = useState(false);

  const concluir = () => {
    if (navBlock && onNext) onNext();
    else navigate(main + "perfil");
  };

  return (
    <div className={"text-white " + (navBlock ? "" : "bg-insigne-bg min-h-screen pt-[var(--nav-h)] pb-16")}>
      <div className="max-w-[520px] mx-auto px-4 md:px-8">
        <div className="bloco p-6 md:p-8">
          {emailParaVerificar ? (
            <FormVerificarEmail email={emailParaVerificar} onSucesso={concluir} />
          ) : pedirTelefone ? (
            <FormCompletarTelefone onConcluir={concluir} />
          ) : (
            <>
              <p className="text-white/70 text-sm mb-5">
                Para finalizar sua compra, entre na sua conta ou crie uma.
              </p>

              <div className="flex border-b border-line mb-6">
                <Aba ativa={aba === "entrar"} onClick={() => setAba("entrar")}>Entrar</Aba>
                <Aba ativa={aba === "criar"} onClick={() => setAba("criar")}>Criar conta</Aba>
              </div>

              {aba === "entrar" ? (
                <FormEntrar onSucesso={concluir} onPrecisaTelefone={() => setPedirTelefone(true)} />
              ) : (
                <FormCriarConta
                  onSucesso={concluir}
                  onPrecisaVerificar={setEmailParaVerificar}
                  onPrecisaTelefone={() => setPedirTelefone(true)}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginOrCreateAccount;
